<template>
  <div
    :class="[{ 'is_finish': isFinish }]"
    class="question"
  >
    <div class="content_wrap">
      <div v-html="headerText" class="contents_text rb"></div>
    </div>
    <slot name="btn"></slot>
  </div>
</template>

<script>
import BaseBtn from "@/components/common/BaseBtn.vue";

export default {
  components: {
    BaseBtn,
  },
  props: {
    isFirst: {
      type: Boolean,
      default: false
    },
    isFinish: {
      type: Boolean,
      default: false // Add default value
    },
    headerText: {
      type: String,
      default: ""
    },
  },
  data() {
    return {
      internalValue: this.value
    }
  },

};
</script>

<style lang="css" scoped>
.content_wrap {
  background-color: #fff;
  box-shadow: 0px 8px 10px 0px #0000001F;
  border-radius: 15px;
  margin-top: 14px;
  padding: 24px 16px 24px 48px;
  position: relative;
}
.content_wrap::before {
  content: '';
  position: absolute;
  left: -16px;
  width: 55px;
  height: 56px;
  background-image: url('~@/assets/images/welcomeCall/fukidasi.svg');
  background-size: cover;
  top: -14px;
}

.contents_text {
  font-size: 14px;
  white-space: pre-wrap;
}



.is_finish .content_wrap {
  padding: 20px 22px;
}

.is_finish .content_wrap::before {
  display: none;
}

.is_finish .contents_text {
  letter-spacing: 1px;
}

/deep/ .contents_text {
  font-size: 14px;
  letter-spacing: 1px;
}

/deep/ ul {
  margin-left: 16px;
}
/deep/ .ex_color {
  color: #1BA0FF;
}

/deep/ .center {
  text-align: center;
}

/deep/ .br_none {
  display: none;
}
</style>



// WEBPACK FOOTER //
// src/components/welcomeCall/Question.vue